import axios from 'axios'
import { setConfig, setReloadAttemptedVersion } from '../state/config'
import store from '../state/store'

const clientVersion =
  process.env.REACT_APP_COMPANION_FRONTEND_VERSION ??
  process.env.APP_COMPANION_FRONTEND_VERSION ??
  '0.0.0'

let fetchPromise = null
let configLoaded = false

export function fetchConfig () {
  if (configLoaded) return Promise.resolve()
  if (fetchPromise) return fetchPromise

  fetchPromise = axios
    .get(`/config.json?t=${Date.now()}`)
    .then(({ data }) => {
      const parsed = typeof data === 'string' ? JSON.parse(sanitize(data)) : data
      store.dispatch(setConfig(parsed))
      handleVersionMismatch(parsed?.version)
      configLoaded = true
      return parsed
    })
    .catch((error) => {
      console.error('Failed to load config.json:', error)
      fetchPromise = null
    })

  return fetchPromise
}

function sanitize (raw) {
  return raw
    .replace(/\r/g, '')
    .replace(/"[^"]*"/g, v => v.replace(/\n/g, '\\n'))
}

function handleVersionMismatch (serverVersion) {
  if (!serverVersion || serverVersion === clientVersion) return

  const { reloadAttemptedForVersion } = store.getState()?.config ?? {}
  if (reloadAttemptedForVersion === serverVersion) return

  // Persist the guard via Redux before reloading so we don't loop.
  store.dispatch(setReloadAttemptedVersion(serverVersion))
  window.location.reload()
}
